import { createContext } from 'react';

export const FileDownloadContext = createContext({ isDownloading: false });
